import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveSearchComponent } from './reactive-search.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedModule } from '../shared/shared.module'
import { ContentSearchComponent } from './content-search/content-search.component'
import { NgxJsonLdModule } from 'ngx-json-ld'
import { PipesModule } from '../../pipes/pipes.module'



@NgModule({
  declarations: [ReactiveSearchComponent, ContentSearchComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgxJsonLdModule,
    PipesModule
  ],
  exports: [ReactiveSearchComponent]
})
export class ReactiveSearchModule { }
